export default __webpack_public_path__ + "static/media/sidebar-icon.90eadb38.svg";